module.exports = __webpack_public_path__ + "img/MS_WeaponSword005.e3f29697.png";